// Geo Location
const geoscript = document.createElement('script'); 
geoscript.src = "https://get.geojs.io/v1/ip/geo.js";

let geoscriptMarkup = document.createDocumentFragment(); 
geoscriptMarkup.appendChild( geoscript ); 
document.head.appendChild( geoscriptMarkup );

// Announcement Bar Country Settings
const euCountries = [{"name":"Andorra","code":"AD"},{"name":"Albania","code":"AL"},{"name":"Austria","code":"AT"},{"name":"Åland Islands","code":"AX"},{"name":"Bosnia and Herzegovina","code":"BA"},{"name":"Belgium","code":"BE"},{"name":"Bulgaria","code":"BG"},{"name":"Belarus","code":"BY"},{"name":"Switzerland","code":"CH"},{"name":"Cyprus","code":"CY"},{"name":"Czech Republic","code":"CZ"},{"name":"Germany","code":"DE"},{"name":"Denmark","code":"DK"},{"name":"Estonia","code":"EE"},{"name":"Spain","code":"ES"},{"name":"Finland","code":"FI"},{"name":"Faroe Islands","code":"FO"},{"name":"France","code":"FR"},{"name":"Guernsey","code":"GG"},{"name":"Greece","code":"GR"},{"name":"Croatia","code":"HR"},{"name":"Hungary","code":"HU"},{"name":"Ireland","code":"IE"},{"name":"Isle of Man","code":"IM"},{"name":"Iceland","code":"IC"},{"name":"Italy","code":"IT"},{"name":"Jersey","code":"JE"},{"name":"Liechtenstein","code":"LI"},{"name":"Lithuania","code":"LT"},{"name":"Luxembourg","code":"LU"},{"name":"Latvia","code":"LV"},{"name":"Monaco","code":"MC"},{"name":"Moldova, Republic of","code":"MD"},{"name":"Macedonia, The Former Yugoslav Republic of","code":"MK"},{"name":"Malta","code":"MT"},{"name":"Netherlands","code":"NL"},{"name":"Norway","code":"NO"},{"name":"Poland","code":"PL"},{"name":"Portugal","code":"PT"},{"name":"Romania","code":"RO"},{"name":"Russian Federation","code":"RU"},{"name":"Sweden","code":"SE"},{"name":"Slovenia","code":"SI"},{"name":"Svalbard and Jan Mayen","code":"SJ"},{"name":"Slovakia","code":"SK"},{"name":"San Marino","code":"SM"},{"name":"Holy See (Vatican City State)","code":"VA"}]

// Redirection Settings Data
const countryCodes = JSON.parse(document.querySelector('#st-country-codes').innerHTML)
const countryUrls = JSON.parse(document.querySelector('#st-country-urls').innerHTML)

const codes_and_urls = {};
countryCodes.forEach((code, i) => {
    if (countryUrls[i] != null) {
        codes_and_urls[code] = countryUrls[i]
    }
});


function geoip(json){
    // Redirection
    const currentCountryCode = json.country_code
    const allCountryCodes = Object.keys(codes_and_urls)
    if (allCountryCodes.includes(currentCountryCode)) {
        const redirectURL = codes_and_urls[currentCountryCode]
        window.location.replace(redirectURL)
    }



    // Announcement Bar
    const customerCountry = json.country
    let code;


    if (customerCountry.includes('United Kingdom')) {
        code = 'UK'
        showMessage(code)
    } else {
        const foundCountry = euCountries.find(country => {
            return country.name.includes(customerCountry)
        })

        if (foundCountry !== undefined) {
            code = 'EU'
            showMessage(code)
        } else {
            code = 'rest'
            showMessage(code)
        }

    }

}

function showMessage(code) {
    const messages = document.querySelectorAll(`[data-country="${code}"]`)
    messages.forEach(message => {
        message.classList.remove('hidden')
    });
}
